module.exports = __webpack_public_path__ + "img/background.680430db.png";